export default __webpack_public_path__ + "static/media/customKitchen4CroppedLeft.c39d38c3.jpeg";